// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=%27gray%27 height=%2720%27 viewBox=%270 0 20 20%27 width=%2720%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M7.293 7.293a1 1 0 011.414 0L10 8.586l1.293-1.293a1 1 0 111.414 1.414l-2 2a1 1 0 01-1.414 0l-2-2a1 1 0 010-1.414z%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  width: 100%;
}

.Insights-section {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
}

.Insights-section h2 {
  color: #6a9c89;
  margin-bottom: 5px;
  font-size: 20px;
}

/* .date-container {
  padding: 0px 7px;
  border: 2px solid #92e2be;
  font-size: 14px;
  color: #92e2be;
  background-color: #fff;
  transition: border-color 0.3s, box-shadow 0.3s;
  border-radius: 4px;
} */
#year,
#month {
  color: #92e2be;
}

/* .date-container select {
  padding: 6px 12px;
  border: none;
  font-size: 14px;
  color: black;
  background-color: #fff;
  transition: border-color 0.3s, box-shadow 0.3s;
} */

.date-container select:focus {
  border-color: #a2d9a8;
  border: none;
  outline: none;
}
.Attnd-details-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.Attnd-card {
  flex: 1 1;
  background-color: #fff;
  padding: 2px 6px;
  border-radius: 8px;
  border: 2px solid rgb(237, 245, 236);
  border-bottom: none;
  box-shadow: 0 3px rgb(232, 237, 231);
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
.heading1 {
  height: 90px;

  padding: 7px 5px;
  box-sizing: border-box;
}
.sub-Heading {
  margin-bottom: 5px;
  font-weight: 200;
  color: #0d7c66;
}
.percent {
  font-size: 12px;
  font-weight: 700;
  color: #092d6e;
  /* margin-bottom: 10px; */
}
.month {
  font-size: 14px;
}
.Attnd-card img {
  width: 90px;
  height: 58px;
  margin-top: 25px;
  object-fit: contain;
}

.Attnd-card h1 {
  margin-bottom: 20px 0;
  font-size: 16px;
  /* color: #92e2be; */
  font-weight: bold;
}
.icon-graph {
  display: flex;
  height: 30px;
  overflow: hidden;
}
.icon {
  color: #53c616;
}
/* .icon-graph p {
  color: #0d7c66;
} */
.Attnd-card-content {
  display: flex;
  flex-direction: column;
}

.Attnd-card-item {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #ddd;
}

.Attnd-card-item:last-child {
  border-bottom: none;
}

.label {
  font-weight: bold;
  color: #555;
}

.percentage {
  font-size: 16px;
  color: #333;
}

.calendar-clock-container {
  display: flex;
  justify-content: space-between;
  width: 45%;
  margin-top: 10px;
  margin-right: 10px;
  /* padding: 15px 15px 0px 0px; */
  font-family: "Poppins", sans-serif;

  & .calendar {
    width: 100%;
    /* height: 100%; */
    /* padding: 5px 5px; */
    border-radius: 8px;
    background-color: #fff;
    border: 2px solid rgb(237, 245, 236);
    box-shadow: 0px 3px rgb(231, 234, 231);
    color: #6b8096;

    & .month-year {
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-shadow: 0 3px rgb(227, 248, 223);
      padding-bottom: 0px;
      margin-bottom: 15px;
      color: #92e2be;
      & .calendarBtn {
        background: none;
        border: none;
        font-size: 1.5rem;
        cursor: pointer;
        color: #6b8096;
        margin: 0 auto;
      }

      & h3 {
        margin: 0;
        font-size: 1.1rem;
        color: rgb(84 141 119);
        font-weight: 600;
      }
    }
  }
}

.myDate {
  color: red;
  color: #769a90;
}

.PunchInTime,
.PunchInLocation,
.PunchOutTime,
.PunchOutLocation,
.myStatus,
.workingHours {
  color: #769a90;
}

.mypunchindata,
.mypunchoutdata,
.mystatusdata,
.myworkingHours {
  color: #014836;
}

.mydata {
  position: relative;
  left: 33px;
}

.mypunchinlocationdata {
  position: relative;
  left: 18px;
}

.mypunchindata {
  position: relative;
  left: 32px;
}

.mypunchoutdata {
  position: relative;
  left: 26px;
}

.mypunchoutlocation {
  position: relative;
  left: 2px;
}

.mystatusdata {
  position: relative;
  left: 88px;
}

.status {
  color: red;
}

.myworkingHours {
  position: relative;
  left: 30px;
}

.myDatedata {
  position: relative;
  top: -16px;
  left: 40px;
  font-size: large;
  color: green;
}

.date {
  color: green;
  font-size: 20px;
  position: relative;
  top: 11px;
  left: 38px;
  display: flex;
  gap: 26px;
}

.weekdays,
.days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  color: rgb(84 141 119);
}
.calanderBtn {
  font-size: 22px;
  color: rgb(84 141 119);
  padding-right: 10px;
  padding-left: 10px;
}

.weekdays span {
  font-weight: bold;
  color: rgb(186, 216, 183);
}

.days .day {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px;
  font-size: 0.9rem;
  color: #6b8096;
}
.day {
  margin-top: -1px;
}

.days .day.active-day {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(237, 245, 236);
  color: #92e2be;
  border-radius: 50%;
}

.hours {
  color: #f57c00;
  font-size: 0.75rem;
  margin-top: 4px;
}

.dayBtn {
  border: none;
  cursor: pointer;
  font-size: 14px;
  padding-bottom: 0px;
}

.pop-up {
  background-color: rgb(255, 255, 255);
  height: fit-content;
  width: fit-content;
  padding: 31px;
  padding-top: 31px;
  padding-bottom: 31px;
  padding-top: 31px;
  padding-top: 31px;
  position: absolute;
  left: 47px;
  z-index: 1000;
  border-radius: 30px;
  padding-top: 0px;
  line-height: 2;
  bottom: 32px;
  padding-bottom: 55px;
  box-shadow: 4px 4px 9px;
}

.closeBtn {
  position: absolute;
  left: 101px;
  padding: 9px;
  padding-right: 9px;
  padding-left: 9px;
  padding-right: 9px;
  padding-left: 9px;
  margin-top: 36px;
  padding-left: 25px;
  justify-content: center;
  align-items: center;
  padding-right: 22px;
  cursor: pointer;
  background: #a8d7c5;
  font-family: karla;
  border-style: none;
  color: white;
  border-radius: 7px;
  font-size: 17px;
}

.pop-up-msg {
  color: green;
}

.clock-graph-section {
  display: flex;
}
.clock-graph-container {
  display: flex;
  width: 65%;
  margin-top: 16px;
  border-radius: 8px;
  gap: 10px;
}

.clock-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 55%;
  background-color: #ffffff;
  border-radius: 15px;
  padding-bottom: 5px;

  border: 2px solid rgb(237, 245, 236);
  padding-top: 10px;
  box-shadow: 0 3px rgb(231, 234, 231);
  & .bottomContainer {
    display: flex;
    padding: 10px 20px;
    border: 1px solid #84c7ae;
    border-radius: 15px;
    gap: 15px;
    color: white;
    margin: 10px 20px 0px 20px;

    .icon-container {
      border-radius: none;
      display: inline-block;
    }
    /* #Attendance-Chart {
      background-color: #1e90ff;
      margin-left: 100px;
    } */
    .icon-container img {
      height: 32px;
      margin-top: 7px;
    }
    .ctaBtn {
      width: 91px;
      height: 51px;
      border: none;
      color: white;
      margin: 0 auto;
      padding: 10px;
      font-size: 13px;
      border-radius: 8px;
      cursor: pointer;
      transition: background-color 0.5s;
    }

    .punch-in {
      background-color: #84c7ae;
    }

    .punch-out {
      background-color: #ff4d4d;
      font-size: 12px;
    }

    .punch-in:hover {
      background-color: #6da593;
    }

    .punch-out:hover {
      background-color: #d43b3b;
    }
    .done-for-day {
      background-color: #84c7ae;
    }
    .done-for-day:hover {
      background-color: #6da593;
    }
  }
}

.small-clock {
  position: relative;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 25px solid rgb(222, 236, 221);
  background: radial-gradient(circle at 50% 50%, #ffffff 30%, #e0f7fa 100%);
  box-shadow: 0 0 10px 5px rgb(232, 231, 255);
}

/* .hour-hand,
.minute-hand,
.second-hand {
  transform-origin: 100% 50%;
  position: absolute;
  width: 50%;
  height: 2px;
  background-color: #000;
  top: 50%;
  left: 0%;
} */

/* .hour-hand {
  height: 4px;
  background-color: #4a4a4a;
  border-radius: 2px;
}

.minute-hand {
  height: 3px;
  background-color: #1e90ff;
  border-radius: 2px;
}

.second-hand {
  height: 1px;
  background-color: #ff4757;
} */

/* .center-circle {
  position: absolute;
  width: 10px;
  height: 10px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ff4757;
  border-radius: 50%;
} */
/* .clock {
  position: relative;
  width: 220px;
  height: 220px;
  background: #d7e7d7;
  border-radius: 50%;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.15) inset;
  margin: 50px auto;
} */

.dial-line {
  /* position: absolute;
  width: 3px;
  height: 12px;
  background: white;
  top: 0;
  left: 50%;
  transform-origin: bottom center; */
  position: absolute;
  background-color: white;
  width: 2px;
  height: 10px;
  left: 50%;
  margin-left: -1px;
  z-index: 2;
  margin-top: -20px;
  transform-origin: 50% 70px;
}

.second-hand {
  position: absolute;
  top: -12%;
  left: 50%;
  transform-origin: bottom center;
}
.hour-hand {
  position: absolute;
  top: 1%;
  left: 49%;
  transform-origin: bottom center;
}

.minute-hand {
  position: absolute;
  top: -12%;
  left: 50%;
  transform-origin: bottom center;
}

.hour-hand {
  width: 5px;
  height: 48px;
  background: #333;
  border-radius: 4px;
  z-index: 3;
}

.minute-hand {
  width: 4px;
  height: 63px;
  background: #1e88e5;
  border-radius: 4px;
  z-index: 2;
}

.second-hand {
  width: 2px;
  height: 62px;
  background: red;
  z-index: 4;
}

.center-circle {
  position: absolute;
  width: 10px;
  height: 10px;
  top: 50%;
  left: 52%;
  transform: translate(-50%, -50%);
  background-color: #ff4757;
  border-radius: 50%;
  z-index: 5;
}

/* .diallines {
  position: absolute;
  background-color: white;
  width: 2px;
  height: 10px;
  left: 50%;
  margin-left: -1px;
  z-index: 2;
  margin-top: -20px;
  transform-origin: 50% 70px;
} */

.time-details {
  margin-top: 10px;
  text-align: center;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.in-time,
.out-time {
  margin: 5px 0;
  color: #6dbbab;
  font-size: 0.9rem;
  font-weight: 600;
  margin-top: 8px;
}

.graph-section {
  width: 90%;
  display: flex;

  color: rgb(84 141 119);
  flex-direction: column;
  border: 2px solid rgb(237, 245, 236);
  border-radius: 15px;
   box-shadow: 0 3px rgb(231, 234, 231);
  & .upperContainer {
    height: 80%;
    text-align: center;
    padding-top: 10px;
    h3 {
      font-size: 19px;
      font-weight: 600;
      margin-bottom: 20px;
    }
  }

  & .bottomContainer {
    display: flex;
    padding: 5px 10px;
    border: 1px solid #84c7ae;
    border-radius: 15px;
    color: white;
    margin: 40px 30px 0px 80px;

    .icon-container {
      margin-left: 20px;
      border-radius: none;
      display: inline-block;
    }

    .punch-in {
      background-color: #84c7ae;
    }

    .punch-out {
      background-color: #ff4d4d;
    }

    .punch-in:hover {
      background-color: #6da593;
    }

    .punch-out:hover {
      background-color: #d43b3b;
    }
    .done-for-day {
      background-color: #84c7ae;
    }
    .done-for-day:hover {
      background-color: #6da593;
    }
  }
  .pop-up {
    background-color: #fff;
    padding: 15px 25px;
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
    border: 1px solid #84c7ae;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    color: #0d7c66;
    font-size: 16px;
    font-weight: bold;
    animation: fade-in-out 3s ease-in-out;
  }

  @keyframes fade-in-out {
    0%,
    90% {
      opacity: 1;
      transform: translateY(0);
    }
    100% {
      opacity: 0;
      transform: translateY(10px);
    }
  }
}
.footer-outer-main {
  height: auto;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  padding: 5px;
}
.footer-card {
  height: 250px;
  width: 32%;
  border-radius: 5px;
  border: 3px solid rgb(237, 245, 236);
  position: relative;
}

.footer-card ul {
  list-style: none;
  font-size: small;
}
.footer-card li {
  padding: 15px;
  margin-bottom: 2px;
  border-bottom: 1px solid #f1f7f5;
  color: #636967;
}
.footer-card span {
  float: right;
}
.footer-card {
  overflow: auto;
}
.footer-card::-webkit-scrollbar {
  display: none;
}
.footer-card h3 {
  height: 40px;
  margin-left: 20px;
  padding: 10px;
  top: 0px;
  color: #0d7c66;
  background-color: white;
  margin-left: 6px;
}

.card_holidays {
  display: flex;
  margin-top: 10px;
  border: 1px solid #e6f5f0;
  background-color: white;
}

.holidays_date {
  height: 50px;
  width: 60px;
  background-color: #f7e7e3;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  margin: 10px;
  font-weight: 600;
  font-size: small;
  border-radius: 10px;
}

.holidayd_heading {
  padding: 5px;
  display: flex;
  justify-content: left;
  align-items: center;
  width: 100%;
  font-size: small;
  color: #636967;
}

.holidays_natioanl {
  display: flex;

  justify-content: center;
  align-items: center;
  margin-left: 0px;
  margin-right: 10px;
  font-size: small;
  color: #636967;
}

.footer_celebration {
  display: flex;
  justify-content: space-between;
  position: sticky;
  top: 0px;
}
.footer_celebration,
select {
  position: sticky;
}

#celebration_date {
  background-color: #d9dfe6;
  margin: 10px;
  width: 88px;
  padding: 0px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  color: #000;
}

.insight_uper {
  display: flex;
  justify-content: space-between;
  position: sticky;
  top: 0px;
}
.insight_uper h3 {
  width: 200px;
}
.insight_select {
  padding-top: 10px;
}

.aproved {
  color: #53c616;
  font-size: 1rem;
}

.custom-select {
  padding: 8px 36px 8px 14px;
  border: 2px solid #00bfae;
  border-radius: 8px;
  background: #f8f9fa;
  font-size: 1rem;
  color: #0d7c66;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
  margin-right: 14px;
  min-width: 120px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(148, 148, 148, 0.07);
  appearance: none;
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 20px 20px;
}

.custom-select:hover,
.custom-select:focus {
  border-color: #0da594;
  background-color: #e0f7fa;
  box-shadow: 0 4px 16px rgba(0, 191, 174, 0.13);
}
/* Option hover effect (works in most Chromium browsers) */
.custom-select option:hover,
.custom-select option:checked {
  background: #b2f2e9;
  color: #00796b;
  border: 1.5px solid #00bfae;
  box-shadow: 0 4px 16px rgba(0, 191, 174, 0.18);
}
.custom-select option {
  background: #e6f9f5;
  color: #0d7c66;
  font-size: 1rem;
  padding: 10px 8px;
  border: 1px solid #b2f2e9;
  box-shadow: 0 2px 8px rgba(0, 191, 174, 0.1);
  transition: background 0.2s, color 0.2s, box-shadow 0.2s, border 0.2s;
}

/* Optional: Add a slight scale effect on open (for supported browsers) */
/* .custom-select:active {
  transform: scale(1.03);
} */
.holiday-view-outer-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
  font-family: sans-serif;
}

.celebration-div-view,
.holiday-div-view {
  border: 2px solid rgb(237, 245, 236);
  border-radius: 10px;
  width: 50%;
  padding: 10px;
  background-color: white;
  overflow: scroll;
  height: 267px;
}

.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  color: #0a7a6f;
  font-weight: bold;
}

.celebration-card,
.holiday-card {
  display: flex;
  align-items: center;
  border-top: 1px solid #d1f3d6;
  padding: 10px 0;
}

.initial-box {
  background-color: #fde6e6;
  color: #000;
  width: 40px;
  height: 40px;
  font-weight: bold;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  margin-right: 10px;
}

.name-date-box {
  flex-grow: 1;
}

.name {
  font-size: 14px;
}

.date-box {
  background-color: #d6d6d6;
  padding: 5px 10px;
  border-radius: 8px;
  font-size: 12px;
}

.holiday-date {
  background-color: #fde6e6;
  padding: 5px 10px;
  border-radius: 8px;
  margin-right: 10px;
  font-weight: bold;
  font-size: 12px;
  width: 100px;
}

.holiday-name {
  flex-grow: 1;
  font-size: 14px;
}

.holiday-type {
  font-size: 12px;
}
/* Responsive adjustments */
@media (max-width: 600px) {
  .custom-select {
    font-size: 0.95rem;
    min-width: 90px;
    padding: 7px 30px 7px 10px;
  }
}
/* responsive */

@media screen and (min-width: 768px) and (max-width: 1024px) {
  .Attnd-details-div {
    gap: 2px;
  }
  .heading1 {
    height: 86px;
    padding: 11px 5px;
    padding: 7px 4px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .month {
    font-size: 10px;
  }
  .percent {
    font-size: 9px;
    font-weight: 700;
    color: #092d6e;
    /* margin-bottom: 10px; */
  }
  .Attnd-card h1 {
    margin-bottom: 20px 0;
    font-size: 10px;
    /* color: #92e2be; */
    font-weight: bold;
  }
  .sub-Heading {
    margin-bottom: 1px;
    /* font-weight: 200; */
    color: #0d7c66;
  }
  .head_graph_img {
    width: 78px;
  }
  .head_graph_img img {
    width: 81px;
  }
  .Attnd-card img {
    width: 77px;
    height: 58px;
    margin-top: 25px;
    object-fit: contain;
  }
  .clock-container {
    width: 46%;
  }
  .graph-section {
    & .upperContainer {
      h3 {
        font-size: 17px;
        font-weight: 600;
        margin-bottom: 20px;
      }
    }
  }
  .clock-container {
    & .bottomContainer {
      display: flex;
      padding: 10px 9px;

      border-radius: 15px;
      gap: 2px;
      color: white;
      margin: 5px 11px 0px 10px;
    }
  }
  .Attnd-card {
    padding: 2px 0px;
  }
}

@media screen and (max-width: 767px) {
  .Insights-section {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .Insights-section h2 {
    font-size: 15px;
  }
  .Attnd-card img {
    display: none;
  }
  .date-container select,
  .custom-select {
    font-size: 14px;
  }
  .Attnd-details-div {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 6px;
    margin-top: 6px;
  }
  .days .day {
    padding: 5px;
  }
  .calendar {
    all: unset;
    box-sizing: border-box;

    border: 2px solid #e0f2f1;
    border-radius: 16px;
    border: 2px solid #e0f2f1;
    background-color: #fff;

    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);

    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }

  /* .Attnd-card {
    flex: none;
    flex-direction: column;
    align-items: flex-start;
    width: 46%; 
    box-sizing: border-box;
    height: 94px;
  } */
  .Attnd-card {
    flex: none;
    flex-direction: column;
    align-items: flex-start;
    width: 46%;
    height: auto;
    box-sizing: border-box;

    border: 2px solid #e0f2f1;
    border-radius: 16px;
    /* background-color: #ffffff; */

    /* ✨ Stronger shadow */
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);

    padding: 7px;
    /* margin-bottom: 16px; */

    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }

  .Attnd-card:hover {
    transform: translateY(-3px) scale(1.01);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
  }

  .Attnd-card img {
    width: 100%;
    height: auto;
    margin-top: 10px;
  }

  .heading1 {
    height: auto;
    font-size: 14px;
    padding: 8px 5px;
  }
  .heading1 p {
    font-weight: 600;
  }
  .percent,
  .month,
  .Attnd-card h1,
  .sub-Heading {
    font-size: 10px;
  }

  .calendar-clock-container,
  .clock-graph-container {
    flex-direction: column;
    width: 100%;
  }

  .calendar-clock-container > *,
  .clock-graph-container > * {
    width: 100%; /* Changed from 103% to prevent horizontal overflow */
    font-size: 1rem; /* Using rem is better for accessibility */
  }

  .clock-container {
    width: 100% !important;
  }

  .graph-section {
    width: 100%;
  }

  .footer-outer-main {
    flex-direction: column;
    gap: 10px;
  }

  .footer-card {
    width: 100%;
  }

  .date {
    flex-direction: column;
    gap: 4px;
    left: 0;
    top: 0;
    font-size: 16px;
    position: relative;
  }

  .myDatedata {
    top: 0;
    left: 0;
    font-size: 14px;
    text-align: left;
  }

  .pop-up {
    width: 90%;
    left: 5%;
    right: 5%;
    padding: 20px;
  }

  .closeBtn {
    left: auto;
    right: 10px;
    margin-top: -39px;
    font-size: 14px;
    padding: 8px 12px;
  }

  .custom-select {
    min-width: 100%;
    font-size: 1rem;
    margin-right: 0;
  }
  .date-container {
    display: flex;
    gap: 15px;
    width: 47%;
  }
  .clock-graph-section {
    display: flex;
    flex-direction: column;
  }
  .custom-select option {
    width: 30px;
  }
  .Attendance-container {
    /* border: 1px solid black; */
    height: auto; /* Changed from fixed 885px to allow the container to grow with its content */
  }
  .weekdays span {
    font-size: 13px;
    font-weight: bold;
    color: #0d7c66;
  }
  .date {
    font-size: 14px;
    position: relative;
    top: 0;
    left: 0;
  }
  .pop-up-msg span {
    margin-bottom: -17px;
    margin-top: -9px;
  }
  .pop-up-msg {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    font-size: medium;
  }
  .pop-up {
    bottom: 355px;
    box-shadow: 60px 60px 60px 60px rgba(0.15, 0.15, 0.15, 0.15);
    border: 2px solid #e0f2f1;
  }
}
/* bithday popup show ui */

.birthday-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1);
  background: linear-gradient(135deg, #ffe6f7 0%, #fffbe6 100%);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  z-index: 9999;
  padding: 32px 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: popup-bounce 2.8s cubic-bezier(0.68, -0.55, 0.27, 1.55);
}

.birthday-content {
  text-align: center;
}

.birthday-emoji {
  font-size: 3rem;
  display: block;
  margin-bottom: 12px;
  animation: emoji-spin 2.2s infinite linear;
}

.birthday-popup h2 {
  font-size: 2rem;
  color: #ff69b4;
  margin-bottom: 8px;
  font-family: "Segoe Script", cursive;
}

.birthday-popup p {
  font-size: 1.1rem;
  color: #333;
  margin-bottom: 0;
}

@keyframes popup-bounce {
  0% {
    transform: translate(-50%, -50%) scale(0.5);
    opacity: 0;
  }
  60% {
    transform: translate(-50%, -50%) scale(1.1);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
}

@keyframes emoji-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/AttendanceDashboard/index.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;;;;;;GAQG;AACH;;EAEE,cAAc;AAChB;;AAEA;;;;;;;GAOG;;AAEH;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,YAAY;;EAEZ,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;GAEG;AACH;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,kCAAkC;;EAElC;IACE,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,oCAAoC;IACpC,sCAAsC;IACtC,cAAc;;IAEd;MACE,aAAa;MACb,8BAA8B;MAC9B,mBAAmB;MACnB,oCAAoC;MACpC,mBAAmB;MACnB,mBAAmB;MACnB,cAAc;MACd;QACE,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,eAAe;QACf,cAAc;QACd,cAAc;MAChB;;MAEA;QACE,SAAS;QACT,iBAAiB;QACjB,sBAAsB;QACtB,gBAAgB;MAClB;IACF;EACF;AACF;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;;EAEnB,oCAAoC;EACpC,iBAAiB;EACjB,oCAAoC;EACpC;IACE,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,0BAA0B;;IAE1B;MACE,mBAAmB;MACnB,qBAAqB;IACvB;IACA;;;OAGG;IACH;MACE,YAAY;MACZ,eAAe;IACjB;IACA;MACE,WAAW;MACX,YAAY;MACZ,YAAY;MACZ,YAAY;MACZ,cAAc;MACd,aAAa;MACb,eAAe;MACf,kBAAkB;MAClB,eAAe;MACf,iCAAiC;IACnC;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,yBAAyB;MACzB,eAAe;IACjB;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,yBAAyB;IAC3B;IACA;MACE,yBAAyB;IAC3B;IACA;MACE,yBAAyB;IAC3B;EACF;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,yEAAyE;EACzE,2CAA2C;AAC7C;;AAEA;;;;;;;;;;GAUG;;AAEH;;;;;;;;;;;;;;;GAeG;;AAEH;;;;;;;;;GASG;AACH;;;;;;;;GAQG;;AAEH;EACE;;;;;;oCAMkC;EAClC,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,UAAU;EACV,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;;;;;;;;;GAUG;;AAEH;EACE,gBAAgB;EAChB,kBAAkB;;EAElB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,aAAa;;EAEb,sBAAsB;EACtB,sBAAsB;EACtB,oCAAoC;EACpC,mBAAmB;GAClB,oCAAoC;EACrC;IACE,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB;MACE,eAAe;MACf,gBAAgB;MAChB,mBAAmB;IACrB;EACF;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,0BAA0B;;IAE1B;MACE,iBAAiB;MACjB,mBAAmB;MACnB,qBAAqB;IACvB;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,yBAAyB;IAC3B;IACA;MACE,yBAAyB;IAC3B;IACA;MACE,yBAAyB;IAC3B;EACF;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;IACxC,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,qCAAqC;EACvC;;EAEA;IACE;;MAEE,UAAU;MACV,wBAAwB;IAC1B;IACA;MACE,UAAU;MACV,2BAA2B;IAC7B;EACF;AACF;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,QAAQ;EACR,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;;EAEb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,QAAQ;AACV;AACA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,QAAQ;AACV;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,aAAa;EACb,+DAA+D;EAC/D,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,+CAA+C;EAC/C,gBAAgB;EAChB,kBAAkB;EAClB,yDAAmR;EACnR,4BAA4B;EAC5B,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,8CAA8C;AAChD;AACA,0DAA0D;AAC1D;;EAEE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,8CAA8C;AAChD;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,4CAA4C;EAC5C,qEAAqE;AACvE;;AAEA,yEAAyE;AACzE;;GAEG;AACH;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,oCAAoC;EACpC,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;AACA,2BAA2B;AAC3B;EACE;IACE,kBAAkB;IAClB,eAAe;IACf,0BAA0B;EAC5B;AACF;AACA,eAAe;;AAEf;EACE;IACE,QAAQ;EACV;EACA;IACE,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,yBAAyB;EAC3B;EACA;IACE,qBAAqB;IACrB,eAAe;IACf,oBAAoB;IACpB,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE;MACE;QACE,eAAe;QACf,gBAAgB;QAChB,mBAAmB;MACrB;IACF;EACF;EACA;IACE;MACE,aAAa;MACb,iBAAiB;;MAEjB,mBAAmB;MACnB,QAAQ;MACR,YAAY;MACZ,yBAAyB;IAC3B;EACF;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;;IAEE,eAAe;EACjB;EACA;IACE,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,QAAQ;IACR,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;IACV,sBAAsB;;IAEtB,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;;IAEtB,2CAA2C;;IAE3C,qDAAqD;EACvD;;EAEA;;;;;;;KAOG;EACH;IACE,UAAU;IACV,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,YAAY;IACZ,sBAAsB;;IAEtB,yBAAyB;IACzB,mBAAmB;IACnB,+BAA+B;;IAE/B,sBAAsB;IACtB,0CAA0C;;IAE1C,YAAY;IACZ,yBAAyB;;IAEzB,qDAAqD;EACvD;;EAEA;IACE,uCAAuC;IACvC,0CAA0C;EAC5C;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;;;;IAIE,eAAe;EACjB;;EAEA;;IAEE,sBAAsB;IACtB,WAAW;EACb;;EAEA;;IAEE,WAAW,EAAE,qDAAqD;IAClE,eAAe,EAAE,0CAA0C;EAC7D;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,OAAO;IACP,MAAM;IACN,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,MAAM;IACN,OAAO;IACP,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,QAAQ;IACR,SAAS;IACT,aAAa;EACf;;EAEA;IACE,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,eAAe;EACjB;EACA;IACE,aAAa;IACb,SAAS;IACT,UAAU;EACZ;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,6BAA6B;IAC7B,YAAY,EAAE,6EAA6E;EAC7F;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,MAAM;IACN,OAAO;EACT;EACA;IACE,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,4DAA4D;IAC5D,yBAAyB;EAC3B;AACF;AACA,0BAA0B;;AAE1B;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,yCAAyC;EACzC,6DAA6D;EAC7D,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kEAAkE;AACpE;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,2CAA2C;IAC3C,UAAU;EACZ;EACA;IACE,2CAA2C;IAC3C,UAAU;EACZ;EACA;IACE,yCAAyC;IACzC,UAAU;EACZ;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["body {\n  width: 100%;\n}\n\n.Insights-section {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2px;\n}\n\n.Insights-section h2 {\n  color: #6a9c89;\n  margin-bottom: 5px;\n  font-size: 20px;\n}\n\n/* .date-container {\n  padding: 0px 7px;\n  border: 2px solid #92e2be;\n  font-size: 14px;\n  color: #92e2be;\n  background-color: #fff;\n  transition: border-color 0.3s, box-shadow 0.3s;\n  border-radius: 4px;\n} */\n#year,\n#month {\n  color: #92e2be;\n}\n\n/* .date-container select {\n  padding: 6px 12px;\n  border: none;\n  font-size: 14px;\n  color: black;\n  background-color: #fff;\n  transition: border-color 0.3s, box-shadow 0.3s;\n} */\n\n.date-container select:focus {\n  border-color: #a2d9a8;\n  border: none;\n  outline: none;\n}\n.Attnd-details-div {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n}\n\n.Attnd-card {\n  flex: 1;\n  background-color: #fff;\n  padding: 2px 6px;\n  border-radius: 8px;\n  border: 2px solid rgb(237, 245, 236);\n  border-bottom: none;\n  box-shadow: 0 3px rgb(232, 237, 231);\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: center;\n}\n.heading1 {\n  height: 90px;\n\n  padding: 7px 5px;\n  box-sizing: border-box;\n}\n.sub-Heading {\n  margin-bottom: 5px;\n  font-weight: 200;\n  color: #0d7c66;\n}\n.percent {\n  font-size: 12px;\n  font-weight: 700;\n  color: #092d6e;\n  /* margin-bottom: 10px; */\n}\n.month {\n  font-size: 14px;\n}\n.Attnd-card img {\n  width: 90px;\n  height: 58px;\n  margin-top: 25px;\n  object-fit: contain;\n}\n\n.Attnd-card h1 {\n  margin-bottom: 20px 0;\n  font-size: 16px;\n  /* color: #92e2be; */\n  font-weight: bold;\n}\n.icon-graph {\n  display: flex;\n  height: 30px;\n  overflow: hidden;\n}\n.icon {\n  color: #53c616;\n}\n/* .icon-graph p {\n  color: #0d7c66;\n} */\n.Attnd-card-content {\n  display: flex;\n  flex-direction: column;\n}\n\n.Attnd-card-item {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 0;\n  border-bottom: 1px solid #ddd;\n}\n\n.Attnd-card-item:last-child {\n  border-bottom: none;\n}\n\n.label {\n  font-weight: bold;\n  color: #555;\n}\n\n.percentage {\n  font-size: 16px;\n  color: #333;\n}\n\n.calendar-clock-container {\n  display: flex;\n  justify-content: space-between;\n  width: 45%;\n  margin-top: 10px;\n  margin-right: 10px;\n  /* padding: 15px 15px 0px 0px; */\n  font-family: \"Poppins\", sans-serif;\n\n  & .calendar {\n    width: 100%;\n    /* height: 100%; */\n    /* padding: 5px 5px; */\n    border-radius: 8px;\n    background-color: #fff;\n    border: 2px solid rgb(237, 245, 236);\n    box-shadow: 0px 3px rgb(231, 234, 231);\n    color: #6b8096;\n\n    & .month-year {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      box-shadow: 0 3px rgb(227, 248, 223);\n      padding-bottom: 0px;\n      margin-bottom: 15px;\n      color: #92e2be;\n      & .calendarBtn {\n        background: none;\n        border: none;\n        font-size: 1.5rem;\n        cursor: pointer;\n        color: #6b8096;\n        margin: 0 auto;\n      }\n\n      & h3 {\n        margin: 0;\n        font-size: 1.1rem;\n        color: rgb(84 141 119);\n        font-weight: 600;\n      }\n    }\n  }\n}\n\n.myDate {\n  color: red;\n  color: #769a90;\n}\n\n.PunchInTime,\n.PunchInLocation,\n.PunchOutTime,\n.PunchOutLocation,\n.myStatus,\n.workingHours {\n  color: #769a90;\n}\n\n.mypunchindata,\n.mypunchoutdata,\n.mystatusdata,\n.myworkingHours {\n  color: #014836;\n}\n\n.mydata {\n  position: relative;\n  left: 33px;\n}\n\n.mypunchinlocationdata {\n  position: relative;\n  left: 18px;\n}\n\n.mypunchindata {\n  position: relative;\n  left: 32px;\n}\n\n.mypunchoutdata {\n  position: relative;\n  left: 26px;\n}\n\n.mypunchoutlocation {\n  position: relative;\n  left: 2px;\n}\n\n.mystatusdata {\n  position: relative;\n  left: 88px;\n}\n\n.status {\n  color: red;\n}\n\n.myworkingHours {\n  position: relative;\n  left: 30px;\n}\n\n.myDatedata {\n  position: relative;\n  top: -16px;\n  left: 40px;\n  font-size: large;\n  color: green;\n}\n\n.date {\n  color: green;\n  font-size: 20px;\n  position: relative;\n  top: 11px;\n  left: 38px;\n  display: flex;\n  gap: 26px;\n}\n\n.weekdays,\n.days {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  text-align: center;\n  color: rgb(84 141 119);\n}\n.calanderBtn {\n  font-size: 22px;\n  color: rgb(84 141 119);\n  padding-right: 10px;\n  padding-left: 10px;\n}\n\n.weekdays span {\n  font-weight: bold;\n  color: rgb(186, 216, 183);\n}\n\n.days .day {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 5px;\n  font-size: 0.9rem;\n  color: #6b8096;\n}\n.day {\n  margin-top: -1px;\n}\n\n.days .day.active-day {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgb(237, 245, 236);\n  color: #92e2be;\n  border-radius: 50%;\n}\n\n.hours {\n  color: #f57c00;\n  font-size: 0.75rem;\n  margin-top: 4px;\n}\n\n.dayBtn {\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  padding-bottom: 0px;\n}\n\n.pop-up {\n  background-color: rgb(255, 255, 255);\n  height: fit-content;\n  width: fit-content;\n  padding: 31px;\n  padding-top: 31px;\n  padding-bottom: 31px;\n  padding-top: 31px;\n  padding-top: 31px;\n  position: absolute;\n  left: 47px;\n  z-index: 1000;\n  border-radius: 30px;\n  padding-top: 0px;\n  line-height: 2;\n  bottom: 32px;\n  padding-bottom: 55px;\n  box-shadow: 4px 4px 9px;\n}\n\n.closeBtn {\n  position: absolute;\n  left: 101px;\n  padding: 9px;\n  padding-right: 9px;\n  padding-left: 9px;\n  padding-right: 9px;\n  padding-left: 9px;\n  margin-top: 36px;\n  padding-left: 25px;\n  justify-content: center;\n  align-items: center;\n  padding-right: 22px;\n  cursor: pointer;\n  background: #a8d7c5;\n  font-family: karla;\n  border-style: none;\n  color: white;\n  border-radius: 7px;\n  font-size: 17px;\n}\n\n.pop-up-msg {\n  color: green;\n}\n\n.clock-graph-section {\n  display: flex;\n}\n.clock-graph-container {\n  display: flex;\n  width: 65%;\n  margin-top: 16px;\n  border-radius: 8px;\n  gap: 10px;\n}\n\n.clock-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 55%;\n  background-color: #ffffff;\n  border-radius: 15px;\n  padding-bottom: 5px;\n\n  border: 2px solid rgb(237, 245, 236);\n  padding-top: 10px;\n  box-shadow: 0 3px rgb(231, 234, 231);\n  & .bottomContainer {\n    display: flex;\n    padding: 10px 20px;\n    border: 1px solid #84c7ae;\n    border-radius: 15px;\n    gap: 15px;\n    color: white;\n    margin: 10px 20px 0px 20px;\n\n    .icon-container {\n      border-radius: none;\n      display: inline-block;\n    }\n    /* #Attendance-Chart {\n      background-color: #1e90ff;\n      margin-left: 100px;\n    } */\n    .icon-container img {\n      height: 32px;\n      margin-top: 7px;\n    }\n    .ctaBtn {\n      width: 91px;\n      height: 51px;\n      border: none;\n      color: white;\n      margin: 0 auto;\n      padding: 10px;\n      font-size: 13px;\n      border-radius: 8px;\n      cursor: pointer;\n      transition: background-color 0.5s;\n    }\n\n    .punch-in {\n      background-color: #84c7ae;\n    }\n\n    .punch-out {\n      background-color: #ff4d4d;\n      font-size: 12px;\n    }\n\n    .punch-in:hover {\n      background-color: #6da593;\n    }\n\n    .punch-out:hover {\n      background-color: #d43b3b;\n    }\n    .done-for-day {\n      background-color: #84c7ae;\n    }\n    .done-for-day:hover {\n      background-color: #6da593;\n    }\n  }\n}\n\n.small-clock {\n  position: relative;\n  width: 150px;\n  height: 150px;\n  border-radius: 50%;\n  border: 25px solid rgb(222, 236, 221);\n  background: radial-gradient(circle at 50% 50%, #ffffff 30%, #e0f7fa 100%);\n  box-shadow: 0 0 10px 5px rgb(232, 231, 255);\n}\n\n/* .hour-hand,\n.minute-hand,\n.second-hand {\n  transform-origin: 100% 50%;\n  position: absolute;\n  width: 50%;\n  height: 2px;\n  background-color: #000;\n  top: 50%;\n  left: 0%;\n} */\n\n/* .hour-hand {\n  height: 4px;\n  background-color: #4a4a4a;\n  border-radius: 2px;\n}\n\n.minute-hand {\n  height: 3px;\n  background-color: #1e90ff;\n  border-radius: 2px;\n}\n\n.second-hand {\n  height: 1px;\n  background-color: #ff4757;\n} */\n\n/* .center-circle {\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #ff4757;\n  border-radius: 50%;\n} */\n/* .clock {\n  position: relative;\n  width: 220px;\n  height: 220px;\n  background: #d7e7d7;\n  border-radius: 50%;\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.15) inset;\n  margin: 50px auto;\n} */\n\n.dial-line {\n  /* position: absolute;\n  width: 3px;\n  height: 12px;\n  background: white;\n  top: 0;\n  left: 50%;\n  transform-origin: bottom center; */\n  position: absolute;\n  background-color: white;\n  width: 2px;\n  height: 10px;\n  left: 50%;\n  margin-left: -1px;\n  z-index: 2;\n  margin-top: -20px;\n  transform-origin: 50% 70px;\n}\n\n.second-hand {\n  position: absolute;\n  top: -12%;\n  left: 50%;\n  transform-origin: bottom center;\n}\n.hour-hand {\n  position: absolute;\n  top: 1%;\n  left: 49%;\n  transform-origin: bottom center;\n}\n\n.minute-hand {\n  position: absolute;\n  top: -12%;\n  left: 50%;\n  transform-origin: bottom center;\n}\n\n.hour-hand {\n  width: 5px;\n  height: 48px;\n  background: #333;\n  border-radius: 4px;\n  z-index: 3;\n}\n\n.minute-hand {\n  width: 4px;\n  height: 63px;\n  background: #1e88e5;\n  border-radius: 4px;\n  z-index: 2;\n}\n\n.second-hand {\n  width: 2px;\n  height: 62px;\n  background: red;\n  z-index: 4;\n}\n\n.center-circle {\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  top: 50%;\n  left: 52%;\n  transform: translate(-50%, -50%);\n  background-color: #ff4757;\n  border-radius: 50%;\n  z-index: 5;\n}\n\n/* .diallines {\n  position: absolute;\n  background-color: white;\n  width: 2px;\n  height: 10px;\n  left: 50%;\n  margin-left: -1px;\n  z-index: 2;\n  margin-top: -20px;\n  transform-origin: 50% 70px;\n} */\n\n.time-details {\n  margin-top: 10px;\n  text-align: center;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.in-time,\n.out-time {\n  margin: 5px 0;\n  color: #6dbbab;\n  font-size: 0.9rem;\n  font-weight: 600;\n  margin-top: 8px;\n}\n\n.graph-section {\n  width: 90%;\n  display: flex;\n\n  color: rgb(84 141 119);\n  flex-direction: column;\n  border: 2px solid rgb(237, 245, 236);\n  border-radius: 15px;\n   box-shadow: 0 3px rgb(231, 234, 231);\n  & .upperContainer {\n    height: 80%;\n    text-align: center;\n    padding-top: 10px;\n    h3 {\n      font-size: 19px;\n      font-weight: 600;\n      margin-bottom: 20px;\n    }\n  }\n\n  & .bottomContainer {\n    display: flex;\n    padding: 5px 10px;\n    border: 1px solid #84c7ae;\n    border-radius: 15px;\n    color: white;\n    margin: 40px 30px 0px 80px;\n\n    .icon-container {\n      margin-left: 20px;\n      border-radius: none;\n      display: inline-block;\n    }\n\n    .punch-in {\n      background-color: #84c7ae;\n    }\n\n    .punch-out {\n      background-color: #ff4d4d;\n    }\n\n    .punch-in:hover {\n      background-color: #6da593;\n    }\n\n    .punch-out:hover {\n      background-color: #d43b3b;\n    }\n    .done-for-day {\n      background-color: #84c7ae;\n    }\n    .done-for-day:hover {\n      background-color: #6da593;\n    }\n  }\n  .pop-up {\n    background-color: #fff;\n    padding: 15px 25px;\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    z-index: 1000;\n    border: 1px solid #84c7ae;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    color: #0d7c66;\n    font-size: 16px;\n    font-weight: bold;\n    animation: fade-in-out 3s ease-in-out;\n  }\n\n  @keyframes fade-in-out {\n    0%,\n    90% {\n      opacity: 1;\n      transform: translateY(0);\n    }\n    100% {\n      opacity: 0;\n      transform: translateY(10px);\n    }\n  }\n}\n.footer-outer-main {\n  height: auto;\n  margin-top: 20px;\n  display: flex;\n  justify-content: space-between;\n  padding: 5px;\n}\n.footer-card {\n  height: 250px;\n  width: 32%;\n  border-radius: 5px;\n  border: 3px solid rgb(237, 245, 236);\n  position: relative;\n}\n\n.footer-card ul {\n  list-style: none;\n  font-size: small;\n}\n.footer-card li {\n  padding: 15px;\n  margin-bottom: 2px;\n  border-bottom: 1px solid #f1f7f5;\n  color: #636967;\n}\n.footer-card span {\n  float: right;\n}\n.footer-card {\n  overflow: auto;\n}\n.footer-card::-webkit-scrollbar {\n  display: none;\n}\n.footer-card h3 {\n  height: 40px;\n  margin-left: 20px;\n  padding: 10px;\n  top: 0px;\n  color: #0d7c66;\n  background-color: white;\n  margin-left: 6px;\n}\n\n.card_holidays {\n  display: flex;\n  margin-top: 10px;\n  border: 1px solid #e6f5f0;\n  background-color: white;\n}\n\n.holidays_date {\n  height: 50px;\n  width: 60px;\n  background-color: #f7e7e3;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 15px;\n  margin: 10px;\n  font-weight: 600;\n  font-size: small;\n  border-radius: 10px;\n}\n\n.holidayd_heading {\n  padding: 5px;\n  display: flex;\n  justify-content: left;\n  align-items: center;\n  width: 100%;\n  font-size: small;\n  color: #636967;\n}\n\n.holidays_natioanl {\n  display: flex;\n\n  justify-content: center;\n  align-items: center;\n  margin-left: 0px;\n  margin-right: 10px;\n  font-size: small;\n  color: #636967;\n}\n\n.footer_celebration {\n  display: flex;\n  justify-content: space-between;\n  position: sticky;\n  top: 0px;\n}\n.footer_celebration,\nselect {\n  position: sticky;\n}\n\n#celebration_date {\n  background-color: #d9dfe6;\n  margin: 10px;\n  width: 88px;\n  padding: 0px;\n  border-radius: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 600;\n  color: #000;\n}\n\n.insight_uper {\n  display: flex;\n  justify-content: space-between;\n  position: sticky;\n  top: 0px;\n}\n.insight_uper h3 {\n  width: 200px;\n}\n.insight_select {\n  padding-top: 10px;\n}\n\n.aproved {\n  color: #53c616;\n  font-size: 1rem;\n}\n\n.custom-select {\n  padding: 8px 36px 8px 14px;\n  border: 2px solid #00bfae;\n  border-radius: 8px;\n  background: #f8f9fa;\n  font-size: 1rem;\n  color: #0d7c66;\n  outline: none;\n  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;\n  margin-right: 14px;\n  min-width: 120px;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(148, 148, 148, 0.07);\n  appearance: none;\n  position: relative;\n  background-image: url(\"data:image/svg+xml;utf8,<svg fill='gray' height='20' viewBox='0 0 20 20' width='20' xmlns='http://www.w3.org/2000/svg'><path d='M7.293 7.293a1 1 0 011.414 0L10 8.586l1.293-1.293a1 1 0 111.414 1.414l-2 2a1 1 0 01-1.414 0l-2-2a1 1 0 010-1.414z'/></svg>\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  background-size: 20px 20px;\n}\n\n.custom-select:hover,\n.custom-select:focus {\n  border-color: #0da594;\n  background-color: #e0f7fa;\n  box-shadow: 0 4px 16px rgba(0, 191, 174, 0.13);\n}\n/* Option hover effect (works in most Chromium browsers) */\n.custom-select option:hover,\n.custom-select option:checked {\n  background: #b2f2e9;\n  color: #00796b;\n  border: 1.5px solid #00bfae;\n  box-shadow: 0 4px 16px rgba(0, 191, 174, 0.18);\n}\n.custom-select option {\n  background: #e6f9f5;\n  color: #0d7c66;\n  font-size: 1rem;\n  padding: 10px 8px;\n  border: 1px solid #b2f2e9;\n  box-shadow: 0 2px 8px rgba(0, 191, 174, 0.1);\n  transition: background 0.2s, color 0.2s, box-shadow 0.2s, border 0.2s;\n}\n\n/* Optional: Add a slight scale effect on open (for supported browsers) */\n/* .custom-select:active {\n  transform: scale(1.03);\n} */\n.holiday-view-outer-container {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-top: 20px;\n  font-family: sans-serif;\n}\n\n.celebration-div-view,\n.holiday-div-view {\n  border: 2px solid rgb(237, 245, 236);\n  border-radius: 10px;\n  width: 50%;\n  padding: 10px;\n  background-color: white;\n  overflow: scroll;\n  height: 267px;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  color: #0a7a6f;\n  font-weight: bold;\n}\n\n.celebration-card,\n.holiday-card {\n  display: flex;\n  align-items: center;\n  border-top: 1px solid #d1f3d6;\n  padding: 10px 0;\n}\n\n.initial-box {\n  background-color: #fde6e6;\n  color: #000;\n  width: 40px;\n  height: 40px;\n  font-weight: bold;\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  margin-right: 10px;\n}\n\n.name-date-box {\n  flex-grow: 1;\n}\n\n.name {\n  font-size: 14px;\n}\n\n.date-box {\n  background-color: #d6d6d6;\n  padding: 5px 10px;\n  border-radius: 8px;\n  font-size: 12px;\n}\n\n.holiday-date {\n  background-color: #fde6e6;\n  padding: 5px 10px;\n  border-radius: 8px;\n  margin-right: 10px;\n  font-weight: bold;\n  font-size: 12px;\n  width: 100px;\n}\n\n.holiday-name {\n  flex-grow: 1;\n  font-size: 14px;\n}\n\n.holiday-type {\n  font-size: 12px;\n}\n/* Responsive adjustments */\n@media (max-width: 600px) {\n  .custom-select {\n    font-size: 0.95rem;\n    min-width: 90px;\n    padding: 7px 30px 7px 10px;\n  }\n}\n/* responsive */\n\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  .Attnd-details-div {\n    gap: 2px;\n  }\n  .heading1 {\n    height: 86px;\n    padding: 11px 5px;\n    padding: 7px 4px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  .month {\n    font-size: 10px;\n  }\n  .percent {\n    font-size: 9px;\n    font-weight: 700;\n    color: #092d6e;\n    /* margin-bottom: 10px; */\n  }\n  .Attnd-card h1 {\n    margin-bottom: 20px 0;\n    font-size: 10px;\n    /* color: #92e2be; */\n    font-weight: bold;\n  }\n  .sub-Heading {\n    margin-bottom: 1px;\n    /* font-weight: 200; */\n    color: #0d7c66;\n  }\n  .head_graph_img {\n    width: 78px;\n  }\n  .head_graph_img img {\n    width: 81px;\n  }\n  .Attnd-card img {\n    width: 77px;\n    height: 58px;\n    margin-top: 25px;\n    object-fit: contain;\n  }\n  .clock-container {\n    width: 46%;\n  }\n  .graph-section {\n    & .upperContainer {\n      h3 {\n        font-size: 17px;\n        font-weight: 600;\n        margin-bottom: 20px;\n      }\n    }\n  }\n  .clock-container {\n    & .bottomContainer {\n      display: flex;\n      padding: 10px 9px;\n\n      border-radius: 15px;\n      gap: 2px;\n      color: white;\n      margin: 5px 11px 0px 10px;\n    }\n  }\n  .Attnd-card {\n    padding: 2px 0px;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .Insights-section {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n  .Insights-section h2 {\n    font-size: 15px;\n  }\n  .Attnd-card img {\n    display: none;\n  }\n  .date-container select,\n  .custom-select {\n    font-size: 14px;\n  }\n  .Attnd-details-div {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    gap: 6px;\n    margin-top: 6px;\n  }\n  .days .day {\n    padding: 5px;\n  }\n  .calendar {\n    all: unset;\n    box-sizing: border-box;\n\n    border: 2px solid #e0f2f1;\n    border-radius: 16px;\n    border: 2px solid #e0f2f1;\n    background-color: #fff;\n\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);\n\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n  }\n\n  /* .Attnd-card {\n    flex: none;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 46%; \n    box-sizing: border-box;\n    height: 94px;\n  } */\n  .Attnd-card {\n    flex: none;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 46%;\n    height: auto;\n    box-sizing: border-box;\n\n    border: 2px solid #e0f2f1;\n    border-radius: 16px;\n    /* background-color: #ffffff; */\n\n    /* ✨ Stronger shadow */\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);\n\n    padding: 7px;\n    /* margin-bottom: 16px; */\n\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n  }\n\n  .Attnd-card:hover {\n    transform: translateY(-3px) scale(1.01);\n    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);\n  }\n\n  .Attnd-card img {\n    width: 100%;\n    height: auto;\n    margin-top: 10px;\n  }\n\n  .heading1 {\n    height: auto;\n    font-size: 14px;\n    padding: 8px 5px;\n  }\n  .heading1 p {\n    font-weight: 600;\n  }\n  .percent,\n  .month,\n  .Attnd-card h1,\n  .sub-Heading {\n    font-size: 10px;\n  }\n\n  .calendar-clock-container,\n  .clock-graph-container {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .calendar-clock-container > *,\n  .clock-graph-container > * {\n    width: 100%; /* Changed from 103% to prevent horizontal overflow */\n    font-size: 1rem; /* Using rem is better for accessibility */\n  }\n\n  .clock-container {\n    width: 100% !important;\n  }\n\n  .graph-section {\n    width: 100%;\n  }\n\n  .footer-outer-main {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .footer-card {\n    width: 100%;\n  }\n\n  .date {\n    flex-direction: column;\n    gap: 4px;\n    left: 0;\n    top: 0;\n    font-size: 16px;\n    position: relative;\n  }\n\n  .myDatedata {\n    top: 0;\n    left: 0;\n    font-size: 14px;\n    text-align: left;\n  }\n\n  .pop-up {\n    width: 90%;\n    left: 5%;\n    right: 5%;\n    padding: 20px;\n  }\n\n  .closeBtn {\n    left: auto;\n    right: 10px;\n    margin-top: -39px;\n    font-size: 14px;\n    padding: 8px 12px;\n  }\n\n  .custom-select {\n    min-width: 100%;\n    font-size: 1rem;\n    margin-right: 0;\n  }\n  .date-container {\n    display: flex;\n    gap: 15px;\n    width: 47%;\n  }\n  .clock-graph-section {\n    display: flex;\n    flex-direction: column;\n  }\n  .custom-select option {\n    width: 30px;\n  }\n  .Attendance-container {\n    /* border: 1px solid black; */\n    height: auto; /* Changed from fixed 885px to allow the container to grow with its content */\n  }\n  .weekdays span {\n    font-size: 13px;\n    font-weight: bold;\n    color: #0d7c66;\n  }\n  .date {\n    font-size: 14px;\n    position: relative;\n    top: 0;\n    left: 0;\n  }\n  .pop-up-msg span {\n    margin-bottom: -17px;\n    margin-top: -9px;\n  }\n  .pop-up-msg {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    font-size: medium;\n  }\n  .pop-up {\n    bottom: 355px;\n    box-shadow: 60px 60px 60px 60px rgba(0.15, 0.15, 0.15, 0.15);\n    border: 2px solid #e0f2f1;\n  }\n}\n/* bithday popup show ui */\n\n.birthday-popup {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) scale(1);\n  background: linear-gradient(135deg, #ffe6f7 0%, #fffbe6 100%);\n  border-radius: 20px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);\n  z-index: 9999;\n  padding: 32px 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: popup-bounce 2.8s cubic-bezier(0.68, -0.55, 0.27, 1.55);\n}\n\n.birthday-content {\n  text-align: center;\n}\n\n.birthday-emoji {\n  font-size: 3rem;\n  display: block;\n  margin-bottom: 12px;\n  animation: emoji-spin 2.2s infinite linear;\n}\n\n.birthday-popup h2 {\n  font-size: 2rem;\n  color: #ff69b4;\n  margin-bottom: 8px;\n  font-family: \"Segoe Script\", cursive;\n}\n\n.birthday-popup p {\n  font-size: 1.1rem;\n  color: #333;\n  margin-bottom: 0;\n}\n\n@keyframes popup-bounce {\n  0% {\n    transform: translate(-50%, -50%) scale(0.5);\n    opacity: 0;\n  }\n  60% {\n    transform: translate(-50%, -50%) scale(1.1);\n    opacity: 1;\n  }\n  100% {\n    transform: translate(-50%, -50%) scale(1);\n    opacity: 1;\n  }\n}\n\n@keyframes emoji-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
